import { colors } from 'component-library/styles/colors';

export const SECTIONS = {
  1: colors.peach,
  2: colors.green,
  3: colors.teal,
};
